import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Ce controller est basé sur `conditional_display_controller.js`
  // De nombreux cas sont gérés dans celui-ci, nous n'avons repris que ceux qui nous servent
  // TODO: utiliser de l'héritage pour centraliser `conditionIterator`
  static targets = ["element"]

  connect() {
    this.disable()
  }

  disable() {
    this.toggleDisablingOnElements()
  }

  // Itère sur tous les éléments à activer/désactiver en fonction de data-disable-if
  toggleDisablingOnElements() {
    this.elementTargets.forEach((elt) => {
      if (elt.dataset.disableIf) {
        let disableConditions = JSON.parse(elt.dataset.disableIf)
        let conditions = this.conditionIterator(disableConditions)
        let disabled = this.disabilityStatusChecker(elt, conditions)
        elt.disabled = disabled
      } else if (elt.dataset.enableIf) {
        let enabledConditions = JSON.parse(elt.dataset.enableIf)
        let conditions = this.conditionIterator(enabledConditions)
        let enabled = this.enabilityStatusChecker(elt, conditions)
        elt.disabled = !enabled
      }
    });
  }

  // private

  // Méthode privée pour vérifier chaque condition dans data-disable-if
  conditionIterator(disableConditions) {
    let conditionArray = []

    for (const [id, condition] of Object.entries(disableConditions)) {
      const input = this.element.querySelector("#" + id) // Trouve l'input par ID

      if (!input) {
        conditionArray.push(false) // Si l'input n'est pas trouvé, retourne false
        continue
      }

      if (condition === "checkbox_checked") {
        conditionArray.push(this.handleCheckboxChecked(input, "checked")) // Gestion des cases à cocher
        continue
      }
      if (condition === "checkbox_unchecked") {
        conditionArray.push(this.handleCheckboxChecked(input, "unchecked")) // Gestion des cases à cocher
        continue
      }

      switch (typeof condition) {
        case "string":
          conditionArray.push(this.handleStringOrNumberCondition(condition, input))
          break
        default:
          conditionArray.push(false)
      }
    }

    return conditionArray
  }

  // Vérifie si une case à cocher est cochée
  handleCheckboxChecked(input, direction) {
    if (direction === "checked") {
      return input?.checked
    } else if (direction === "unchecked") {
      return !input?.checked
    }
  }

  // Gère les conditions basées sur une chaîne de caractères ou un nombre (ex: "checked", valeur numérique)
  handleStringOrNumberCondition(condition, input) {
    if (condition === "not_empty") {
      return input?.value.trim() !== "" // Vérifie si l'input n'est pas vide
    }
    return condition.toString() === input?.value // Sinon, compare la valeur
  }

  // Détermine la logique de vérification des conditions (AND par défaut, OR si spécifié)
  disabilityStatusChecker(elt, conditions) {
    // "AND" par défaut : toutes les conditions doivent être vraies
    if (elt.dataset.conditionOperator && elt.dataset.conditionOperator === "OR") {
      return conditions.some(Boolean) // Utilise "OR" si spécifié dans data-condition-operator="OR"
    } else {
      return conditions.every(Boolean) // "AND" par défaut
    }
  }

  enabilityStatusChecker(elt, conditions) {
    if (elt.dataset.conditionOperator && elt.dataset.conditionOperator === "OR") {
      return conditions.some(Boolean) // Utilise "OR" si spécifié dans data-condition-operator="OR"
    } else {
      return conditions.every(Boolean) // "AND" par défaut
    }
  }
}
